module.exports = __webpack_public_path__ + "static/indoor-window-cleaning-edmonton-0cd76bc810b7e5f55aec2d7301625f9c.jpg";